export const Logo = ({ compact = false }) => (
  <span className="flex items-center">
    <img
      src="/logo-mark.jpg"
      alt="MP Coaching"
      data-testid="brand-logo"
      className={`${compact ? "h-9 w-9" : "h-11 w-11"} rounded-lg shadow-lg shadow-[#6a0dad]/30`}
    />
  </span>
);
